// ADR-109 Rule RA-06 — apps/remote_assist/domMirror/dataMask.ts
//
// قرارداد سراسری فرانت‌اند: هر فیلد حساس باید data-mask="always" یا
// data-mask="financial" داشته باشد. این ماژول تنها منبع حقیقتِ اعمال این
// قرارداد است — همه‌جای دیگر (capture.ts، اسکرین‌شات تیکت در آینده) باید
// از همین تابع استفاده کنند، نه یک پیاده‌سازی موازی.
//
// نکته‌ی امنیتی حیاتی: data-mask="always" هرگز، تحت هیچ پارامتری، قابل
// نمایش نیست — این تابع حتی پارامتر ورودی برایش نمی‌گیرد.

export type MaskLevel = "always" | "financial";

const MASK_PLACEHOLDER = "•••••••";

export interface MaskingOptions {
  /** Rule RA-06 — فقط برای requester_scope=platform_vendor معنا دارد. */
  financialDataVisible: boolean;
}

/**
 * یک DOM subtree را کلون می‌کند و تمام عناصر [data-mask] را طبق قوانین
 * Rule RA-06 جایگزین می‌کند. ورودی اصلی هرگز mutate نمی‌شود.
 */
export function applyDataMasking(root: Element, options: MaskingOptions): Element {
  const clone = root.cloneNode(true) as Element;

  // حذف عناصری که نباید در آینه‌ی ارسالی به پشتیبان قرار گیرند (مانند بنر وضعیت سشن)
  const noMirrorElements = clone.querySelectorAll<HTMLElement>("[data-no-remote-mirror]");
  noMirrorElements.forEach((el) => el.remove());

  const maskedElements = clone.querySelectorAll<HTMLElement>("[data-mask]");

  maskedElements.forEach((el) => {
    const level = el.getAttribute("data-mask") as MaskLevel | null;

    if (level === "always") {
      maskElement(el);
      return;
    }

    if (level === "financial" && !options.financialDataVisible) {
      maskElement(el);
    }
    // level === "financial" && financialDataVisible === true -> دست‌نخورده می‌ماند
  });

  return clone;
}

function maskElement(el: HTMLElement): void {
  if (el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement) {
    el.value = MASK_PLACEHOLDER;
    el.setAttribute("value", MASK_PLACEHOLDER);
    return;
  }
  el.textContent = MASK_PLACEHOLDER;
}

/**
 * برای استفاده در جریان کلیک/تایپ (Rule RA-08): بررسی این‌که آیا یک عنصر
 * هدف اصلاً باید submit/تزریق رویداد را از سمت پشتیبان بپذیرد یا نه —
 * صفحات/فیلدهای data-mask="always" هرگز نباید ورودی خارجی بپذیرند، حتی با
 * پرمیشن کنترل کامل.
 */
export function isInputInjectionBlocked(target: Element): boolean {
  return target.closest('[data-mask="always"]') !== null || target.closest("[data-no-remote-control]") !== null;
}
